import { isSponsoredCampaign } from 'services/campaignDimension';
import { isAdminNetworkAccountType } from '../../../account-management';

export const realtimeReportVisibilityCondition = ({ dimension, isRealtime, selectedAccount }) =>
    isSponsoredCampaign(dimension) && isRealtime && !isAdminNetworkAccountType(selectedAccount?.type);
